module.exports = __webpack_public_path__ + "img/howto_sp03.ea9adfa2.png";